import {ChangeDetectionStrategy, Component, contentChild, input, InputSignal} from "@angular/core";


@Component({
    selector: 'ramme-tittel',
    template: `
        <span>
            <ng-content></ng-content>
        </span>
        <span class="tittel--linje"></span>
    `,
    host: {'data-testid': 'tittel'},
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RammeTittelKomponent {
}


@Component({
    selector: 'ramme-innhold',
    template: `<ng-content></ng-content>`,
    host: {'data-testid': 'innhold'},
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RammeInnholdKomponent {
}

/** Komponent som viser ramme med tittel og innhold.
 * Tittel kan angis via attributtet `tittel` eller via `<ramme-tittel>`-komponenten.
 * Innhold må angis via `<ramme-innhold>`-komponenten*/
@Component({
    selector: 'ramme-med-tittel',
    template: `
        @if (tittelElement()) {
            <ng-container>
                <div [attr.id]="tittelElementId" class="tittel-kontainer">
                    <ng-content select="ramme-tittel"></ng-content>
                </div>
            </ng-container>
        } @else {
            <ng-container>
                <ramme-tittel [attr.id]="tittelElementId">{{ tittelSomStreng() }}</ramme-tittel>
            </ng-container>
        }

        <ng-container>
            <ng-content select="ramme-innhold"></ng-content>
        </ng-container>
    `,
    styleUrl: 'ramme-med-tittel.scss',
    host: {'role':'region', '[attr.aria-labelledby]':'tittelElementId'},
    imports: [
        RammeTittelKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RammeMedTittelKomponent {
    static instansTeller = 0;

    tittelElement = contentChild(RammeTittelKomponent);
    innholdElement = contentChild.required(RammeInnholdKomponent);

    /** Angir tittel, alternativt angis tittel via `<ramme-tittel>`-komponenten */
    tittelSomStreng = input<string | null>(null, {alias: 'tittel'});

    readonly tittelElementId = `_ramme-tittel-${RammeMedTittelKomponent.instansTeller++}`;
}
